var _linearGradient, _path, _linearGradient2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4SZycE1EPntPg_vaQEuHCa",
    x1: 24,
    x2: 24,
    y1: 10.282,
    y2: 42.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fba62d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#fc8e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#fe602a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#ff4329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3829"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#4SZycE1EPntPg_vaQEuHCa)",
    d: "M40,42H8c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h32c1.1,0,2,0.9,2,2v32C42,41.1,41.1,42,40,42z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4SZycE1EPntPg_vaQEuHCb",
    x1: 5.712,
    x2: 26.001,
    y1: 6.137,
    y2: 26.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa53d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#e17a2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#d15d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb5223"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#4SZycE1EPntPg_vaQEuHCb)",
    d: "M30,30c8.847-8.848-3.981-19-3.981-19l-5.005-5H8C6.9,6,6,6.9,6,8v13.967l4,4 C10,25.967,21.153,38.848,30,30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.019,11c11.429,7.698,7.732,16.187,7.732,16.187s3.25,3.634,1.936,6.813 c0,0-1.34-2.226-3.588-2.226c-2.166,0-3.44,2.226-7.8,2.226C14.591,34,10,25.967,10,25.967c8.747,5.7,14.719,1.663,14.719,1.663 C20.778,25.364,12,14,12,14c7.299,6.155,11,8,11,8c-1.882-1.542-8-9-8-9c4.224,4.238,13.307,10.378,13.307,10.378 C30.691,16.834,26.019,11,26.019,11z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.c2a0c1159ba3161611ded9baa79bb885.svg";
export { ForwardRef as ReactComponent };